import type { VFC } from 'react';

import type {
	ReferenceEntity,
	MultiBodiedExtensionActions,
} from '@atlaskit/editor-common/extensions';

import type { ExperienceAttributes } from '@confluence/experience-tracker/entry-points/ExperienceEvent.ts';
import type { RendererExtensionHandlers } from '@confluence/fabric-extension-lib/entry-points/extensionTypes.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { Mode, Extension } from '@confluence/macro-tracker/entry-points/types.ts';

export const PageIncludeSSRExtensionHandler: LoadableType<
	{
		mode: Mode;
		extensionKey?: string;
		attributes?: ExperienceAttributes;
		contentId: string;
	} & {
		node: Extension;
	} & {
		showTemplateVariablesInPreview?: boolean;
		showTemplateInputInPreview?: boolean;
		spaceKey: string;
		spaceId?: string;
		references?: ReferenceEntity[];
		multiBodiedExtensionActions?: MultiBodiedExtensionActions;
		noOverlay?: boolean;
		isConnectMacro?: boolean;
	} & {
		appearance?: string;
		Renderer: VFC<any>;
		getExtensionHandlers: (options: any) => RendererExtensionHandlers;
	}
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageIncludeSSRExtensionHandler" */ '../src/PageIncludeSSRExtensionHandler.tsx'
			)
		).PageIncludeSSRExtensionHandler,
});
